<template>
    <div class="wrapper">
        <div class="index">
            <div class="info-message">
                Scroll evt. for at se alle felter
            </div>
            <div class="email-chooser" v-if="showEmailChooser">
                Send test e-mail til:
                <br>
                <input type="text" v-model="$store.state.form.default.email" />
            </div>
            <div class="step" v-show="currentStep === -1">
                Our form is currently unavailable.
                <br><br>
                We expect to be up and running again by 8PM today.
                <br><br>
                Sorry for the inconvenience.
            </div>
            <div class="step" v-show="currentStep === 0">
                <div class="buttons">
                    <div class="buttons__left">
                        <button class="swedish-link" @click="goToSwedishForm()" style="display:inline-flex;align-items:center;margin-right:10px;">
                            <img src="/static/img/sweden.png" height="16" />&nbsp;
                            Svensk kunde?
                        </button>
                        <button class="swedish-link" @click="goToFaroeIslandsForm()" style="display:inline-flex;align-items:center;">
                            <img src="/static/img/faroe_islands.png" height="16" />&nbsp;
                            Færøsk kunde?
                        </button>
                    </div>
                    <div class="buttons__right" style="display:none;">
                        <button
                            @click="currentStep = 1;"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Kontaktformular
                        </div>
                        <div class="step-counter">
                            &nbsp;
                        </div>
                    </div>
                    <div class="step__description">
                        Her er der en beskrivelse
                    </div>
                </div>
                <div class="content">
                    Kære kunde,
                    <br><br>
                    Denne kontaktformular vedligeholdes ikke længere.
                    <br><br>
                    Du finder nu al hjælp, vejledning og mulighed for kontakt i vores selvbetjening.
                    <br><br>
                    <a href="https://selvbetjening.quooker.dk?utm_source=qservice&utm_medium=referral&utm_campaign=serviceform" style="color:#C80236;font-family:'AvenirHeavyOblique';" target="_blank">Gå til selvbetjening &rarr;</a>
                </div>
            </div>
            <div class="step" v-show="currentStep === 1">
                <div class="nordic-chooser" v-if="showCubeErrorcodesModal">
                    <div class="inner" v-if="cubeErrorPage === 1">
                        <div class="title">
                            Drejer din henvendelse sig om CUBE?
                        </div>
                        <div class="choose">
                            <button @click="cubeErrorPage = 2">
                                Ja
                            </button>
                            <button @click="currentStep = 2;showCubeErrorcodesModal = false;">
                                Nej, gå videre
                            </button>
                        </div>
                    </div>
                    <div class="inner" v-if="cubeErrorPage === 2">
                        <div class="title">
                            Viser din CUBE en af følgende fejlkoder?
                        </div>
                        <div class="text">
                            Tryk på fejlkoden herunder. Hvis du ikke ser en fejlkode, kan du blot fortsætte.
                        </div>
                        <div class="text" style="padding:15px 0;">
                            <button v-for="errorcode in cubeErrorcodes" @click="cubeErrorPage = 3;selectedCubeErrorcode = errorcode;$store.state.form.problem.description = `CUBE fejlkode ${errorcode.code} - ${errorcode.description}`" style="width:unset;margin:0 5px;">
                                {{ errorcode.code }}
                            </button>
                        </div>
                        <div class="choose">
                            <button @click="currentStep = 2;showCubeErrorcodesModal = false;">
                                Nej, gå videre
                            </button>
                        </div>
                    </div>
                    <div class="inner" v-if="cubeErrorPage === 3 && selectedCubeErrorcode">
                        <div class="title">
                            CUBE fejlkode {{ selectedCubeErrorcode.code }}
                        </div>
                        <div class="text">
                            <!--{{ selectedCubeErrorcode.title }}
                            <br><br>-->
                            {{ selectedCubeErrorcode.description }}
                            <br><br>
                            <b style="color:#C80236;">Mulig løsning</b><br>
                            {{ selectedCubeErrorcode.solution }}
                        </div>
                        <div class="choose">
                            <button @click="currentStep++;showCubeErrorcodesModal = false;cubeErrorPage = 1">
                                Gå videre
                            </button>
                        </div>
                    </div>
                </div>
                <div class="nordic-chooser" v-if="showEContainerModal">
                    <div class="inner">
                        <div class="title">
                            Kære Quooker-kunde
                        </div>
                        <div class="text">
                            Vi har vigtig info om din beholder/hane, der betyder at du i stedet skal læse nærmere <a href="https://quooker.dk/service/udfasning-beholder" style="color:#C80236;text-decoration:underline;">her</a> for at komme videre.
                            <br><br>
                            Mvh. Quooker
                            <br><br>
                            <img src="../../../static/svg/Quooker_Logo.svg" style="height:30px;object-fit:contain;" />
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        &nbsp;
                    </div>
                    <div class="buttons__right">
                        <span v-if="$store.state.form.container.serial && $store.state.form.container.serial.length < 6 || $store.state.form.validatedContainer === null || $store.state.form.faucet.serial === null || $store.state.form.faucet.serial === ''">
                            Udfyld alle felter markeret med "<span class="red-star">*</span>" for at gå videre&nbsp;
                        </span>
                        <button
                            :disabled="$store.state.form.container.serial && $store.state.form.container.serial.length < 6 || $store.state.form.validatedContainer === null || $store.state.form.faucet.serial === null || $store.state.form.faucet.serial === ''"
                            @click="($store.state.form.cube.serial ? (showCubeErrorcodesModal = true) : currentStep = 2); setPixel('Vaelg hane')"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Angiv serienummer
                        </div>
                        <div class="step-counter">
                            1 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Her er der en beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din beholder <span class="red-star">*</span>
                            </label>
                            Serienummeret finder du på et mærkat på siden af beholderen. Hvis du er i tvivl, se
                            <a href="javascript:void(0)" @click="showSerialHelper = !showSerialHelper">her</a>.
                            <div class="nordic-chooser" v-show="showSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Sådan finder du dit serienummer</h4>
                                    <br>
                                    <img src="static/img/serienummer-beholder.png" style="width:100%;max-height:240px;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showSerialHelper = false">
                                        Luk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.container.serial" />
                            <div class="mts">
                                <span class="green" v-if="$store.state.form.validatedContainer !== null && $store.state.form.container.serial.length > 5">
                                    {{ $store.state.form.validatedContainer.name }}
                                </span>
                                <span v-else>
                                    <span class="red" v-if="$store.state.form.container.serial && $store.state.form.container.serial.length > 0">
                                        {{ faucetSerial ? 'Det ser ud til, at du er ved at indtaste serienummeret på din hane og ikke din beholder. Skriv venligst serienummeret på din beholder i dette felt for at gå videre.' : 'Intet match fundet' }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din hane <span class="red-star">*</span>
                            </label>
                            Du finder serienummeret på den sorte ledning fra armaturet. Hvis du er i tvivl, se
                            <a href="javascript:void(0)" @click="showTapSerialHelper = !showTapSerialHelper">her</a>.
                            <div class="nordic-chooser" v-show="showTapSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Sådan finder du dit serienummer</h4>
                                    <br>
                                    <img src="static/img/serienummer-hane.png" style="max-height:240px;width:100%;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showTapSerialHelper = false">
                                        Luk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.faucet.serial" />
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din CUBE
                            </label>
                            Hvis du har en CUBE køleenhed. Serienummeret findes på et klistermærke på enten forsiden eller bagsiden af CUBE.
                            Hvis du er i tvivl, se
                            <a href="javascript:void(0)" @click="showCubeSerialHelper = !showCubeSerialHelper">her</a>.
                            <div class="nordic-chooser" v-show="showCubeSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Sådan finder du dit serienummer</h4>
                                    <br>
                                    <img src="static/img/serienummer-cube.png" style="max-height:240px;width:100%;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showCubeSerialHelper = false">
                                        Luk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.cube.serial" />    
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 2">
                <div class="nordic-chooser" v-if="showNordicChooser">
                    <div class="inner">
                        <div class="title">
                            Twintaps eller single tap Nordic?
                        </div>
                        <div class="text">
                            Twintaps består af både en kogende vandhane og et almindeligt blandingsbatteri fra Quooker.
                            Single tap er når du kun har en kogende vandhane fra Quooker.
                        </div>
                        <div class="choose">
                            <button @click="chooseNordic('Twintaps')">
                                Twintaps
                            </button>
                            <button @click="chooseNordic('Single Tap')">
                                Single tap
                            </button>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 1">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.validatedFaucet === null"
                            @click="currentStep = 3; setPixel('Vaelg overflade')"
                        >
                            <span v-if="$store.state.form.validatedFaucet === null">
                                Hane skal vælges
                            </span>
                            <span v-else>
                                Videre
                            </span>
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Vælg hane
                        </div>
                        <div class="step-counter">
                            2 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="faucets">
                        <div
                            class="faucet"
                            v-for="faucet in sortedFaucets"
                            v-bind:key="faucet.title"
                            @click="validateFaucet(faucet)"
                            :class="{'selected': $store.state.form.validatedFaucet !== null && $store.state.form.validatedFaucet.title === faucet.title}"
                        >
                            <div class="image">
                                <img :src="faucet.image" />
                            </div>
                            <div class="title">
                                {{ faucet.title }}
                            </div>
                            <div class="description">
                                {{ faucet.description }}
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
            <div class="step" v-show="currentStep === 3">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 2">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.faucet.surface === null"
                            @click="currentStep = 4; setPixel('Problem aarsag')"
                        >
                            <span v-if="$store.state.form.faucet.surface === null">
                                Overflade skal vælges
                            </span>
                            <span v-else>
                                Videre
                            </span>
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Vælg overflade
                        </div>
                        <div class="step-counter">
                            3 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="surfaces">
                        <div
                            class="surface"
                            v-for="surface in sortedSurfaces"
                            v-bind:key="surface.title"
                            @click="$store.state.form.faucet.surface = surface.title"
                            :class="{'selected': $store.state.form.faucet.surface === surface.title}"
                        >
                            <div class="image">
                                <img class="sm" :src="surface.image" />
                            </div>
                            <div class="title">
                                {{ surface.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 4">
                
                <div class="nordic-chooser" v-if="showRestartHelper">
                    <div class="inner">
                        <div class="close" @click="showRestartHelper = false">
                            X
                        </div>
                        <h4>
                            Sådan nulstiller du din Quooker
                        </h4>
                        Mange fejl kan med succes afhjælpes, med en simpel genstart og nulstilling af softwaren i Quookeren.
                        <a href="https://quooker.dk/service/fejlguide/genstart-nulstil" rel="noopener" target="_blank">
                            Se her hvordan du genstarter din Quooker korrekt</a>.
                        <br><br>
                        Det er ikke nok bare at hive stikket ud!
                        <br><br>
                        Vi anbefaler du prøver at genstarte din Quooker korrekt nogle gange, inden du kontakter os.
                        <br><br>
                        <div class="option" @click="showRestartHelper = false">
                            Luk vindue
                        </div>
                    </div>
                </div>
                <div class="nordic-chooser" v-if="showBlinkHelper">
                    <div class="inner">
                        <div class="close" @click="showBlinkHelper = false; $store.state.form.problem.questions[2].answer = null">
                            X
                        </div>
                        <h4>
                            Hvordan blinker din Quooker?
                        </h4>
                        Hvis Quookeren opdager en fejl/uregelmæssighed vil lyset i hanen og på beholderen blinke i et fast mønster.
                        <br><br>
                        <b style="font-size:90%;">OBS! I nogle tilfælde er det kun beholderen der blinker, tjek derfor altid både hanen og beholderen.</b>
                        <br><br>
                        <div class="option-wrapper">
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '2 blink'; showBlinkHelper = false">
                                <div class="blink two">
                                    <div class="blink__title">
                                        2 blink
                                    </div>                                            
                                    <img src="/static/gif/blinktwo.gif" />
                                </div>
                            </div>
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '4 blink'; showBlinkHelper = false; show4BlinkHelper = true">
                                <div class="blink four">
                                    <div class="blink__title">
                                        4 blink
                                    </div>
                                    <img src="/static/gif/blinkfour.gif" />
                                </div>
                            </div>
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '3 + 1 blink'; showBlinkHelper = false">
                                <div class="blink threeplusone">
                                    <div class="blink__title">
                                        3 + 1 blink
                                    </div> 
                                    <img src="/static/gif/blinkthreeplusone.gif" />
                                </div>
                            </div>
                        </div>
                        <div align="center">
                            <div class="option last" @click="$store.state.form.problem.questions[2].extra = 'Andet / ved ikke'; showBlinkHelper = false">
                                Andet / ved ikke
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nordic-chooser" v-if="show4BlinkHelper">
                    <div class="inner" style="max-height:90%;overflow-y:scroll;">
                        <div class="close" @click="show4BlinkHelper = false">
                            X
                        </div>
                        <h4>
                            4 blink
                        </h4>
                        4 blink på hane, eller beholder, betyder at softwaren i din Quooker registrerer en fejl i forbindelse med temperaturmålingen i din Quooker.
                        <br><br>
                        <b style="color:#C80236;">Tips!</b><br>
                        Fejlen kan ofte nulstilles, ved at give beholderen et "kuldechok"<br><br>
                        Det gøres ved at slukke på beholderens top og tappe alt kogende vand af beholderen. Når vandet ikke længere er kogende, lader man vandet løbe i yderligere 2 minutter således at vandet er helt koldt.<br><br>
                        Derefter skal du følge vores almindelige <a href="https://quooker.dk/service/fejlguide/genstart-nulstil" target="_blank" class="main">nulstillingsprocedure</a>, hvorefter beholderen burde være klar til brug efter ca. 20 minutter.<br><br>
                        Manøvren kan være nødvendig at gentage et par gange<br><br>
                        <button style="width:unset;outline:none;background:#C80236;color:#fff;border:1px solid #e6003f!important;padding:5px 10px;white-space:nowrap;" @click="show4BlinkHelper = false">
                            OK, det prøver jeg!
                        </button>
                    </div>
                </div>

                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 3">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.problem.questions[0].answer === null || $v.$store.state.form.problem.$invalid || $store.state.form.problem.questions[1].answer === null || $store.state.form.problem.questions[2].answer === null || $store.state.form.problem.description === null"
                            @click="currentStep = 5; setPixel('Garanti')"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Problem / årsag
                        </div>
                        <div class="step-counter">
                            4 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div
                        class="line"
                        v-for="(question, index) in $store.state.form.problem.questions" v-bind:key="question.question"
                        style="margin-bottom:15px;"
                    >
                        <div class="left">
                            <label>
                                {{ question.question }}
                            </label>
                            <div v-if="question.slug === 'restart'">
                                <a href="https://quooker.dk/service/fejlguide/genstart-nulstil" rel="noopener" target="_blank">
                                    <i class="fal fa-video fa-fw" />
                                    Sådan nulstiller du din Quooker
                                </a>
                            </div>
                        </div>
                        <div class="right flex" v-if="index === 2">
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true; showBlinkHelper = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false; $store.state.form.problem.questions[index].extra = null"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nej
                            </button>
                        </div>
                        <div class="right flex" v-else-if="index === 3">
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false; showRestartHelper = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nej
                            </button>
                        </div>
                        <div class="right flex" v-else>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nej
                            </button>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Beskrivelse af problemet
                            </label>
                            Beskriv dit problem eller spørgsmål i feltet her. Ved fejl er det vigtigt at uddybe symptomet; Hvad gør du og hvad sker der?
                        </div>
                        <div class="right">
                            <textarea class="form-control" placeholder="Beskrivelse af problem" rows="4" v-model="$store.state.form.problem.description" />
                            <div class="flex-wrapper mts">
                                <validation-messages :data="$v.$store.state.form.problem.description" :show="true" />    
                                <div class="validator" v-if="$store.state.form.problem.description" :class="{'validated': $store.state.form.problem.description.length > 19}">
                                    {{ $store.state.form.problem.description.length }} / 20
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 5">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 4">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.warranty.underWarranty === null || $store.state.form.warranty.underWarranty === true && $store.state.form.warranty.installationMonth === null || $store.state.form.warranty.underWarranty === true && $store.state.form.warranty.installationYear === null"
                            @click="currentStep = 6; setPixel('Vedhæft filer')"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Garanti
                        </div>
                        <div class="step-counter">
                            5 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line">
                        <div class="left">
                            <label>
                                Er produktet under 24 måneder gammelt?
                            </label>
                        </div>
                        <div class="right flex">
                            <button
                                @click="$store.state.form.warranty.underWarranty = true"
                                :class="{'selected': $store.state.form.warranty.underWarranty === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.warranty.underWarranty = false"
                                :class="{'selected': $store.state.form.warranty.underWarranty === false}"
                            >
                                Nej
                            </button>
                        </div>
                    </div>
                    <div class="line" v-if="$store.state.form.warranty.underWarranty === true">
                        <div class="left">
                            <label>
                                Installationsdato
                            </label>
                            Vælg måned og år din Quooker blev installeret
                        </div>
                        <div class="right flex">
                            <select class="form-control" v-model="$store.state.form.warranty.installationMonth">
                                <option v-for="month in months" v-bind:key="month">
                                    {{ month }}
                                </option>
                            </select>
                            <select class="form-control" v-model="$store.state.form.warranty.installationYear">
                                <option v-for="year in years" v-bind:key="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 6">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 5">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            @click="currentStep = 7; setPixel('Kontaktinformationer')"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Vedhæft filer
                        </div>
                        <div class="step-counter">
                            6 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <file-upload
                        intro="Valgfrit - Upload billeder, video eller andre relevante filer, hvis du er blevet bedt om dette.<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har mislyde, skal vi bede om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har fået en fysisk skade, skal vi bede om billeder"
                        singleFileUploaded="fil uploadet"
                        multipleFilesUploaded="filer uploadet"
                        noFilesUploaded="Ingen filer uploadet"
                        addFilesButton="Tilføj fil(er)"
                        remove="Fjern"
                    />
                </div>
            </div>
            <div class="step" v-show="currentStep === 7">
                <div class="nordic-chooser" v-if="showAddressModal">
                    <div class="inner">
                        <div class="title">
                            Validering af adresse
                        </div>
                        <div class="text">
                            Vi beklager, men der skete en fejl ved validering af din adresse. Udfyld venligst dette felt med din fulde adresse for at sende formularen.
                            <br><br>
                            <input class="form-control" type="text" placeholder="Indtast din fulde adresse" v-model="$store.state.form.contact.address" />
                            <br><br>
                            <button @click="submitManualAddress()">Send</button>
                        </div>
                    </div>
                </div>
                <div id="emailMockup" style="display:none;position:absolute;z-index:999;background:#f8f9fc;width:100%;" v-if="currentStep === 7">
                    <div style="max-width:100%;width:400px;margin: 25px auto;">
                        <div class="intro">
                            <div v-html="$store.state.texts.danish" style="white-space:pre-wrap;" />
                            <br>
                            <b>Vigtigt!</b> Har du spørgsmål bedes du besvare denne mail.
                            <br><br>
                            Herunder finder du en kopi af dine indtastede oplysninger:
                            <br><br>
                        </div>
                        <div class="summary" style="background:#fff;padding:30px;border:1px solid #ccc;box-shadow:0px 5px 15px rgba(0,0,0,0.15);">
                            <div>
                                <b>Sagsnummer</b>
                                <br>
                                {{ $store.state.form.meta.id }}
                            </div>
                            <br>
                            <div>
                                <b>Beholder</b>
                                <br>
                                <span v-if="$store.state.form.container.serial !== null">
                                    {{ $store.state.form.container.serial.toUpperCase() }} - {{ $store.state.form.validatedContainer.name }}
                                </span>
                            </div>
                            <br>
                            <div v-if="$store.state.form.cube.serial !== null">
                                <b>CUBE</b>
                                <br>
                                Serienummer: {{ $store.state.form.cube.serial }}
                            </div>
                            <br v-if="$store.state.form.cube.serial !== null">
                            <div>
                                <b>Hane</b>
                                <br>
                                {{ $store.state.form.validatedFaucet.title }}
                                <span v-if="$store.state.form.faucet.meta !== null">
                                    ({{ $store.state.form.faucet.meta }})
                                </span>
                                <span>
                                    <br>
                                    {{ $store.state.form.faucet.surface }}
                                </span>
                                <span v-if="$store.state.form.faucet.serial !== null">
                                    <br>
                                    {{ $store.state.form.faucet.serial }}
                                </span>
                            </div>
                            <br>
                            <div>
                                <b>Spørgsmål</b>
                                <br>
                                <div v-for="q in $store.state.form.problem.questions">
                                    {{ q.question }}:
                                    <b v-if="q.answer">
                                        Ja
                                    </b>
                                    <b v-else>Nej</b>
                                    <b v-if="q.extra">
                                        ({{ q.extra }})
                                    </b>
                                </div>
                            </div>
                            <br>
                            <div>
                                <b>Beskrivelse af problemet</b>
                                <br>
                                {{ $store.state.form.problem.description }}
                            </div>
                            <br>
                            <div>
                                <b>Garanti</b>
                                <br>
                                Er produktet under 24 måneder?
                                <b v-if="$store.state.form.warranty.underWarranty">Ja</b>
                                <b v-else>Nej</b>
                                <br>
                                <span v-if="$store.state.form.warranty.underWarranty">
                                    Installationsdato:
                                    <b>{{ $store.state.form.warranty.installationMonth }} {{ $store.state.form.warranty.installationYear }}</b>
                                </span>
                            </div>
                            <br>
                            <div>
                                <b>Kontaktoplysninger</b>
                                <br>
                                {{ $store.state.form.contact.firstname }}
                                {{ $store.state.form.contact.lastname }}
                                <br>
                                <span v-if="$store.state.form.contact.company !== null">
                                    Firma: {{ $store.state.form.contact.company }}
                                </span>
                                <br v-if="$store.state.form.contact.company !== null">
                                {{ $store.state.form.contact.phone }}
                                <br>
                                {{ $store.state.form.contact.email }}
                                <br>
                                {{ $store.state.form.contact.validatedAddress }}
                                <div v-if="addressIssues">
                                    <b>
                                        OBS! Adressen er ikke valideret med DAWA.
                                    </b>
                                </div>
                            </div>
                            <br>
                            <div>
                                <b>Vedhæftninger</b>
                                <br>
                                <div v-if="$store.state.form.attachments.length > 0">
                                    <ul>
                                        <li v-for="attachment in $store.state.form.attachments" v-bind:key="attachment.name">
                                            <a :href="attachment.path">
                                                {{ attachment.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    Ingen filer uploadet
                                </div>
                            </div>
                        </div>
                        <div class="outro" align="center">
                            <br><br>
                            Med venlig hilsen
                            <br>
                            <b>Quooker Skandinavien A/S</b>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 6">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <span v-if="loading">
                            <i class="fal fa-spinner fa-spin" />
                            &nbsp;
                        </span>
                        <button
                            :disabled="loading || $v.$store.state.form.contact.$invalid || $store.state.form.terms.accepted === false"
                            @click="submitForm()"
                        >
                            Send
                            <i class="fal fa-envelope" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Kontaktinformationer
                        </div>
                        <div class="step-counter">
                            7 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line three-columns">
                        <div class="left">
                            <label>
                                Fornavn <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.firstname" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.firstname" />
                        </div>
                        <div class="left middle">
                            <label>
                                Efternavn <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.lastname" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.lastname" />
                        </div>
                        <div class="left">
                            <label>
                                Firma (valgfri)
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.company" />
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                E-mail <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.email" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.email" />
                        </div>
                        <div class="right">
                            <label>
                                Telefon <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.phone" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.phone" />
                        </div>
                    </div>
                    <div class="line address-field">
                        <div class="left fw autocomplete-container">
                            <label>
                                Adresse <span class="red-star">*</span>
                            </label>
                            <label style="display:none!important;">
                                A
                            </label>
                            <input
                                id="dawa-autocomplete-input"
                                type="text"
                                class="form-control"
                                v-model="$store.state.form.contact.address"
                                :disabled="$store.state.form.contact.validatedAddress !== null"
                                name="2f3b92h83nfuiei9h"
                                autocomplete="new-password"
                            />
                            <div class="mts">
                                <span v-if="$store.state.form.contact.validatedAddress === null">
                                    Vælg adresse fra listen ved indtastning
                                </span>
                                <a
                                    href="javascript:void(0)"
                                    v-if="$store.state.form.contact.validatedAddress !== null"
                                    @click="resetAddress()"
                                >
                                    Klik her, hvis du vil vælge en anden adresse
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left fw terms">
                            <input type="checkbox" v-model="$store.state.form.terms.accepted" />
                            <div>
                                Jeg har læst og accepterer Quookers <a href="https://quooker.dk/privatlivspolitik" rel="noopener" target="_blank">privatlivs- og forretningsbetingelser</a> <span class="red-star">*</span>
                            </div>
                        </div>
                        <div class="right">

                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-if="currentStep === 8">
                <div class="header">
                    <div class="step__title">
                        <div>
                            INDSENDT - Tak for din henvendelse
                        </div>
                    </div>
                </div>
                <div class="content" style="font-size:1.2em;">
                    <div v-html="$store.state.texts.danish" style="white-space:pre-wrap;" />
                    <br>
                    Sagsnummer: <b>{{ $store.state.form.meta.id }}</b>
                    <br><br>
                    Vi har sendt dig en mail hvor dit sagsnummer også er noteret. Modtager du ikke denne email inden for en time, så tjek først din spam-mappe og kontakt os dernæst evt. telefonisk i stedet.
                </div>
            </div>
        </div>
        <div class="q-progress-bar" v-if="currentStep !== 7">
            <div class="line" :style="'width:' + ((16.66 * currentStep) - 16.66) + '%;'" />
            <div class="q-progress-bar__step" :class="{'active': currentStep === 1}">
                1
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 2}">
                2
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 3}">
                3
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 4}">
                4
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 5}">
                5
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 6}">
                6
            </div>
        </div>
        <!--<br>
        <div class="store">
            <ul>
                <li v-for="(item, key) in $store.state.form" style="margin:20px 0;">
                    {{ key }}:
                    <ul>
                        <li v-for="(subItem, key) in item">
                            {{ key }}: {{ subItem }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>-->
    </div>
</template>

<style lang="scss">
@import '../../styles/main.scss';
</style>

<script>
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import ValidationMessages from '@/components/validation/validationMessages'
import FileUpload from '@/components/elements/file-upload'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import axios from 'axios'

export default {
    data () {
        return {
            faucetSerial: false,
            addressIssues: false,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showCubeInfo: false,
            showNordicChooser: false,
            showAddressModal: false,
            showEContainerModal: false,
            showCubeErrorcodesModal: false,
            cubeErrorPage: 1,
            selectedCubeErrorcode: null,
            cubeErrorcodes: [
                {
                    code: 'E1',
                    title: 'Ventilator defekt / ventilator sidder fast / ventilator ikke tilsluttet',
                    description: 'Ventilatoren virker ikke',
                    solution: 'Prøv at rengøre ventilatoren med en børste eller støvsuger. Hvis problemet fortsætter, skal du blot gå videre.',
                    icon: false
                },
                {
                    code: 'E2',
                    title: 'Utilstrækkelig kølemiddel / forkert placering af temperatursensor',
                    description: 'Utilstrækkelig køling',
                    solution: 'Tryk på genstartsikonet på displayet. Hvis problemet fortsætter, skal du blot gå videre.',
                    icon: true
                },
                {
                    code: 'E3',
                    title: 'Pumpen virker ikke; ingen vandforsyning / for meget luft i systemet / højdesensor ikke tilsluttet',
                    description: 'Beholderen med vand med brus er ikke fyldt op',
                    solution: 'Kontrollér, om afspærringsventilen er åben (kontraintuitivt). Tjek, at slangerne ikke er bukkede. Tryk på genstartsikonet på displayet. Hvis problemet fortsætter, skal du blot gå videre.',
                    icon: true
                },
                {
                    code: 'E4',
                    title: 'Lækage eller kondens',
                    description: 'For meget vand i drypbakken',
                    solution: 'Kontakt os ved at gå videre i denne formular.',
                    icon: false
                },
                {
                    code: 'E9',
                    title: 'Vandforsyningen er ikke tilsluttet under opstartsprocessen',
                    description: 'Pumpens hastighed er for høj under opstartsprocessen',
                    solution: 'Kontrollér, om afspærringsventilen er åben (kontraintuitivt). Tjek, at slangerne ikke er bukkede. Hvis problemet fortsætter, skal du blot gå videre.',
                    icon: false
                }
            ],
            faucets: [
                {
                    title: 'Front',
                    type: 'front',
                    description: 'Koldt, varmt og kogende vand',
                    image: 'static/img/front-2.png'
                },
                {
                    title: 'Fusion Round',
                    type: 'fusion',
                    description: 'Koldt, varmt og kogende vand',
                    image: 'static/img/Fusion_Round_krom-1.png'
                },
                {
                    title: 'Fusion Square',
                    type: 'fusion',
                    description: 'Koldt, varmt og kogende vand',
                    image: 'static/img/Fusion-Square-krom-kopi.png'
                },
                {
                    title: 'Nordic Round',
                    type: 'nordic',
                    description: 'Kogende vand',
                    image: 'static/img/Nordic_round.png'
                },
                {
                    title: 'Nordic Square',
                    type: 'nordic',
                    description: 'Kogende vand',
                    image: 'static/img/Nordic_square.png'
                },
                {
                    title: 'Flex',
                    type: 'flex',
                    description: 'Koldt, varmt og kogende vand med udtræk',
                    image: 'static/img/flex.png'
                },
                {
                    title: 'Classic Fusion Round',
                    type: 'cl-fusion',
                    description: 'Koldt, varmt og kogende vand',
                    image: 'static/img/Classic_Fusion_Round_krom.png'
                },
                {
                    title: 'Classic Fusion Square',
                    type: 'cl-fusion',
                    description: 'Koldt, varmt og kogende vand',
                    image: 'static/img/Classic_Fusion_Square_krom.png'
                },
                {
                    title: 'Classic Nordic Round',
                    type: 'cl-nordic',
                    description: 'Kogende vand',
                    image: 'static/img/Classic_Nordic_Round_krom.png'
                },
                {
                    title: 'Classic Nordic Square',
                    type: 'cl-nordic',
                    description: 'Kogende vand',
                    image: 'static/img/Classic_Nordic_Square_krom.png'
                },
                {
                    title: 'Modern',
                    type: 'classic',
                    description: 'Kogende vand',
                    image: 'static/img/modern.png'
                },
                {
                    title: 'Classic',
                    type: 'classic',
                    description: 'Kogende vand',
                    image: 'static/img/classic.png'
                },
                {
                    title: 'Basic',
                    type: 'classic',
                    description: 'Kogende vand',
                    image: 'static/img/Basic.png'
                },
                {
                    title: 'Design',
                    type: 'classic',
                    description: 'Kogende vand',
                    image: 'static/img/design.png'
                }
            ],
            surfaces: [
                {
                    title: 'Krom',
                    fits: 'flex,nordic,fusion,classic,cl-nordic,cl-fusion',
                    image: 'static/img/overflade_krom-e1515075015591.png'
                },
                {
                    title: 'Børstet krom',
                    fits: 'nordic,fusion,classic',
                    image: 'static/img/borstet_krom-e1515075356409.png'
                },
                {
                    title: 'Rustfrit stål',
                    fits: 'front,nordic,fusion,flex,cl-nordic,cl-fusion',
                    image: 'static/img/rustfrit_staal-e1515074931468.png'
                },
                {
                    title: 'Black',
                    fits: 'front,fusion,flex',
                    image: 'static/img/sort-e1515075215324.png'
                },
                {
                    title: 'Messing',
                    fits: 'nordic,fusion',
                    image: 'static/img/messing-e1515075074718.png'
                },
                {
                    title: 'Bruneret messing',
                    fits: 'nordic,fusion,cl-fusion',
                    image: 'static/img/bruneret_messing-e1515075086176.png'
                },
                {
                    title: 'Guld',
                    fits: 'fusion,classic',
                    image: 'static/img/guld-1-e1515075138363.png'
                },
                {
                    title: 'Rustfrit stål-look',
                    fits: 'classic',
                    image: 'static/img/rustfrit_staal-e1515074931468.png'
                },
                {
                    title: 'Rose copper',
                    fits: 'front,flex,fusion',
                    image: 'static/img/rose-copper.png'
                },
                {
                    title: 'Gunmetal',
                    fits: 'front,flex,fusion',
                    image: 'static/img/gunmetal.png'
                },
                {
                    title: 'Ved ikke',
                    fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                    image: 'static/img/ved_ikke-e1515075230382.png'
                }
            ],
            months: [
                'Januar',
                'Februar',
                'Marts',
                'April',
                'Maj',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'December'
            ],
            serials: [
                // 3 litres
                { identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // 7 litres
                { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' },
                { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // 7 litres (Quookers own serial numbers) - Same as above but with 7 instead of 5
                { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' },
                { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // Combi
                { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' },
                { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' },
                { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' },
                { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' },
                { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' },
                { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' },
                { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' },
                { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' },
                { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // New serial numbers 2021 (starting with "R")
                { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                // NEW START
                { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' },
                { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' },
                { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' },
                { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' },
                { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }
                // NEW END
                // Servicekit 55020 + 10005 passer på alle combier (stort + lille servicekit), som IKKE er NEW INLET
                // Servicekit 10000 passer på alle PRO3 + PRO7, som IKKE er NEW INLET
                // På widget skal alle combier linke til det store servicekit
                // breakpoint null = all new inlet for at sikre der ikke bliver bestilt servicekit til en NEW INLET
            ]
        }
    },
    mounted () {
        Bugsnag.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new BugsnagPluginVue()]
        })
        let randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)
        this.$store.state.form.meta.id = 'QSF-' + randomNumber
        var inputElm = document.getElementById('dawa-autocomplete-input')
        let self = this
        try {
            window.dawaAutocomplete.dawaAutocomplete(inputElm, {
                select: (selected) => {
                    // console.log('Valgt adresse: ' + selected.tekst)
                    console.log(selected)
                    self.$store.state.form.contact.validatedAddress = selected.tekst
                    self.$store.state.form.contact.address = selected.tekst
                }
            })
        } catch (err) {
            alert('ADVARSEL! Det ser ud til at du benytter en ældre browser. Vores formularer supporterer desværre ikke ældre browsere. Vi anbefaler, at du benytter en nyere version af Google Chrome eller Firefox for at benytte formularen. Kontakt os på service@quooker.dk for at få yderligere hjælp.')
        }
    },
    methods: {
        goToSwedishForm () {
            window.location = window.location + 'se'
        },
        goToFaroeIslandsForm () {
            window.location = window.location + 'fo'
        },
        setPixel (title) {
            window.fbq('trackCustom', title)
        },
        resetAddress () {
            this.$store.state.form.contact.validatedAddress = null
            this.$store.state.form.contact.address = null
        },
        validateFaucet (faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true
            } else {
                this.$store.state.form.faucet.meta = null
            }
            this.$store.state.form.validatedFaucet = faucet
        },
        chooseNordic (type) {
            this.$store.state.form.faucet.meta = type
            this.showNordicChooser = false
        },
        validateSerial () {
            function compare (a, b) {
                if (a.identifier > b.identifier) {
                    return -1
                }
                if (a.identifier < b.identifier) {
                    return 1
                }
                return 0
            }

            // Set input variable from input field value
            let input = this.$store.state.form.container.serial
            if (input !== null) {
                input = input.toUpperCase()
            }
            // let filter = /(\d+)/g
            // let formattedInput = input.match(filter)
            // let lastChar = input.substr(input.length - 1)

            // Sort array to ensure best match comes first (Z-A)
            this.serials.sort(compare)

            // clear validatedContainer
            this.$store.state.form.validatedContainer = null

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true
                } else {
                    this.faucetSerial = false
                }

                // Check if "outdated" container (E?)
                let eIdentifiers = ['VC3', 'VC5', 'VC7', 'CC4', 'CC5', 'CC7', 'CP4', 'CP5', 'CP7']
                eIdentifiers.forEach((identifier) => {
                    let match = identifier === input.toUpperCase()
                    if (match) {
                        this.showEContainerModal = true
                        return
                    }
                })

                this.serials.every((serial) => {
                    if (input.match('^' + serial.identifier)) {
                        this.$store.state.form.validatedContainer = serial
                        /* if (serial.servicekitNo) {
                            if (formattedInput.toString().length < 8) {
                                if (serial.breakpoint) {
                                    if (formattedInput < serial.breakpoint) {
                                        showServicekit(serial.servicekitUrl)
                                    } else {
                                        showSwop(serial.swopUrl)
                                    }
                                } else {
                                    showServicekit(serial.servicekitUrl)
                                }
                            } else {
                                if (lastChar === '0') {
                                    showServicekit(serial.servicekitUrl)
                                } else {
                                    showSwop(serial.swopUrl)
                                }
                            }
                        } else {
                            showSwop(serial.swopUrl)
                        } */
                        return false
                    }
                    return true
                })
            }
        },
        submitForm () {
            if (this.$store.state.form.contact.validatedAddress === null || this.$store.state.form.contact.validatedAddress === undefined || this.$store.state.form.contact.validatedAddress === '') {
                this.addressValidationError()
                return
            }
            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                let randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)
                this.$store.state.form.meta.id = 'QSF-' + randomNumber
            }
            this.loading = true
            /*eslint-disable */
            let Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } }
            /*eslint-enable */

            let emailElement = document.getElementById('emailMockup').innerHTML
            let quookerEmail = emailElement

            let formData = new FormData()
            formData.append('email', this.$store.state.form.contact.email)
            formData.append('country', 'DK')
            formData.append('html', quookerEmail)
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname)
            formData.append('form_meta_id', this.$store.state.form.meta.id)
            axios.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                this.loading = false
                this.currentStep = 8
            })
            .catch((err) => {
                console.log(err)
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.')
                this.loading = false
            })
        },
        addressValidationError () {
            this.addressIssues = true
            this.showAddressModal = true
        },
        submitManualAddress () {
            this.$store.state.form.contact.validatedAddress = this.$store.state.form.contact.address
            this.showAddressModal = false
            setTimeout(() => {
                this.submitForm()
            }, 1000)
        }
    },
    computed: {
        showEmailChooser () {
            let url = location.href
            if (url.includes('localhost') || url.includes('test')) {
                return true
            } else {
                return false
            }
        },
        sortedFaucets () {
            if (this.$store.state.form.validatedContainer !== null) {
                let arr = []
                this.faucets.forEach((faucet) => {
                    if (this.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet)
                    }
                })
                return arr
            }
        },
        sortedSurfaces () {
            if (this.$store.state.form.validatedFaucet !== null) {
                let arr = []
                this.surfaces.forEach((surface) => {
                    if (surface.fits.includes(this.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface)
                    }
                })
                return arr
            }
        },
        formattedEmailBody () {
            let body = {
                personalizations: [
                    {
                        to: [
                            {
                                email: 'nr@deveo.dk',
                                name: 'Nicolai Ramsby'
                            }
                        ],
                        subject: 'Hello, World!'
                    }
                ],
                content: [
                    {
                        type: 'text/plain',
                        value: 'Heya!'
                    }
                ],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            }
            return body
        },
        years () {
            let currentYear = new Date().getFullYear()
            let years = []
            let startYear = 2004

            while (startYear <= currentYear) {
                years.push(startYear++)
            }

            return years
        }
    },
    components: {
        ValidationMessages,
        FileUpload
    },
    validations: {
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required,
                            minLength: minLength(20),
                            maxLength: maxLength(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required,
                            minLength: minLength(2)
                        },
                        lastname: {
                            required,
                            minLength: minLength(2)
                        },
                        email: {
                            required,
                            email
                        },
                        phone: {
                            required
                        }
                    }
                }
            }
        }
    },
    watch: {
        '$store.state.form.container.serial': 'validateSerial'
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?580a3240